import { useEffect, useState } from "react";
import { makeStyles, Typography, Grid } from "@material-ui/core";
import { InfoBox } from "../../../../components/boxes/InfoBox";
import { COLORS } from "../../../../theme/colors";
import { Box } from "../Box";
import { GroupButton } from "../GroupButton";
import { Header } from "../Header";
import { PeopleBarProgress } from "./PeopleBarProgress";
import { getData } from "../../../../services";

const useStyles = makeStyles((theme) => ({
  chartTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: "#25282B",
  },
  info: {
    marginRight: theme.spacing(4),
  },
}));

export const UnconnectedTenants = ({ building, onClose }) => {
  const classes = useStyles();
  const [buildingData, setBuildingData] = useState([]);
  useEffect(() => {
    getData(
      `/praas/v1/dashboard/map/tenancy-management/${building.id}/?type=unconnected_tenants`,
      (data) => setBuildingData(data)
    );
  }, []);

  return (
    <Box>
      <Header building={buildingData} title="High rate of unconnected tenants" onClose={onClose} />
      <InfoBox color="#FFE6E6">
        <Typography variant="h4" style={{ color: COLORS.red }}>
          {buildingData?.unconnected_tenants_rate || 0}% of the tenants in this building are not connected
        </Typography>
      </InfoBox>

      <Typography className={classes.chartTitle} variant="h4">
        Unconnected tenants
      </Typography>
      <InfoBox color="#EAE9ED40">
        <Grid container alignItems="center" justifyContent="center">
          <Grid className={classes.info} item>
            <Typography variant="h3" style={{ color: COLORS.red }}>
              {buildingData?.unconnected_tenants_rate || 0}%
            </Typography>
            <Typography>This building</Typography>
          </Grid>
          <Grid item>
            <PeopleBarProgress percentage={buildingData?.unconnected_tenants_rate || 0} />
          </Grid>
        </Grid>
        <Grid container alignItems="center" justifyContent="center">
          <Grid className={classes.info} item>
            <Typography variant="h4" style={{ fontWeight: "bold" }}>
              {buildingData?.portfolio_avg_unconnected_tenants_rate || 0}%
            </Typography>
            <Typography>Portfolio avg</Typography>
          </Grid>
          <Grid item>
            <PeopleBarProgress percentage={buildingData?.portfolio_avg_unconnected_tenants_rate || 0} />
          </Grid>
        </Grid>
      </InfoBox>

      <GroupButton buttons={[{ text: "SHARE" }]} />
    </Box>
  );
};
